import SessionTimeoutModal from './SessionTimeoutModal';

export default SessionTimeoutModal;
